const templates: Record<string, string> = {
  globalChatOpenConversationWith: "Open conversation with {name}",
  globalChatUnreadMessages: "{count} unread messages",
  globalChatPinnedMessagesCount: "{count} pinned messages",
  globalChatOpenPinnedMessage: "Open pinned message: {preview}",
  globalChatOpenSearchResult: "Open search result from {date}: {preview}",
  globalChatReactWith: "React with {emoji}",
  globalChatReactionCount: "{emoji}: {count}",
  globalChatRemoveFile: "Remove {name}",
  globalChatTooManyFiles: "You can only select up to {count} files.",
  fileSizeMoreThan: "File size must be less than {size}MB.",
};

type StringsDictionary = {
  [key: string]: any;
  formatString: (
    keyOrTemplate: string,
    values: Record<string, string | number>,
  ) => string;
};

const strings: StringsDictionary = {
  formatString(keyOrTemplate: string, values: Record<string, string | number>) {
    const template = templates[keyOrTemplate] || keyOrTemplate;
    return Object.entries(values).reduce(
      (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
      template,
    );
  },
  searcgContactPlaceholder: "Search contacts",
  selectChat: "Select chat",
  chatTitle: "Chat",
  groupChat: "Group chat",
  noChats: "No chats",
  loading: "Loading...",
  sending: "Sending...",
  retry: "Retry",
  failedStatus: "Failed",
  pendingStatus: "Pending",
  readStatus: "Read",
  cancelBtn: "Cancel",
  calendarModalDeleteBtn: "Delete",
  acceptBtn: "Accept",
  rejectBtn: "Reject",
  joinBtn: "Join",
  pinChat: "Pin chat",
  unpinChat: "Unpin chat",
  pinnedChats: "Pinned",
  recentChats: "Recent",
  muteChat: "Mute chat",
  enableNotifications: "Enable notifications",
  disableNotifications: "Disable notifications",
  blockChat: "Block chat",
  unblockChat: "Unblock chat",
  leaveChat: "Leave chat",
  leave: "Leave",
  block: "Block",
  unblock: "Unblock",
  chatBlocked: "Chat is blocked",
  viewParticipants: "View participants",
  participantsTitle: "Participants",
  searchParticipants: "Search participants",
  participant: "Participant",
  speaker: "Speaker",
  write: "Write",
  confirmLeaveChat: "Leave this chat?",
  confirmBlockChat: "Block this chat?",
  confirmUnblockChat: "Unblock this chat?",
  typeMessagePlaceholder: "Type message...",
  textChatUnavailable: "Chat is unavailable",
  textChatBlockedByMe: "You blocked this chat",
  textChatBlockedByAnotherUser: "This chat is blocked",
  textChatExpired: "This chat is expired",
  textChatDisabled: "Chat is disabled",
  textChatLeft: "You left this chat",
  textChatReconnecting: "Reconnecting...",
  globalChatAttachmentPreview: "Attachment",
  globalChatVoiceMessagePreview: "Voice message",
  globalChatMessagePreview: "Message",
  globalChatPinnedMessagePreview: "Pinned message",
  globalChatSupportConversation: "Support conversation",
  globalChatSelectedConversation: "Selected conversation",
  globalChatBackToContacts: "Back to contacts",
  globalChatOpenMessageSearch: "Search messages",
  globalChatMessageSearch: "Message search",
  globalChatSearchMessages: "Search messages",
  globalChatSearchMessagesInConversation: "Search messages in conversation",
  globalChatSearchingMessages: "Searching...",
  globalChatClearMessageSearch: "Clear message search",
  globalChatCloseMessageSearch: "Close message search",
  globalChatClear: "Clear",
  globalChatMessageSearchResults: "Message search results",
  globalChatOpeningSearchResult: "Opening search result...",
  globalChatSearchFailed: "Message search failed",
  globalChatMessageUnavailable: "Message is unavailable",
  globalChatPinnedMessages: "Pinned messages",
  globalChatPinnedMessagesList: "Pinned messages list",
  globalChatViewAllPinnedMessages: "View all",
  globalChatClosePinnedMessages: "Close pinned messages",
  globalChatOpeningPinnedMessage: "Opening pinned message...",
  globalChatUnpinAllPinnedMessages: "Unpin all",
  globalChatUnpinAllPinnedMessagesTitle: "Unpin all pinned messages?",
  globalChatUnpinAllPinnedMessagesDescription:
    "This will remove every pinned message from this conversation.",
  globalChatDeleteMessageTitle: "Delete message?",
  globalChatDeleteMessageDescription: "This message will be removed from chat.",
  globalChatReplyingTo: "Replying to",
  globalChatClearReply: "Clear reply",
  globalChatEditingMessage: "Editing message",
  globalChatCancelEditingMessage: "Cancel editing",
  globalChatSendMessage: "Send message",
  globalChatAttachFile: "Attach file",
  globalChatAttachFileInput: "Attach file input",
  globalChatToggleEmojiPicker: "Toggle emoji picker",
  globalChatMentionSuggestions: "Mention suggestions",
  globalChatSelectedFiles: "Selected files",
  globalChatUnsupportedFileType: "Unsupported file type",
  globalChatAudioAttachmentUseVoiceControls:
    "Use voice controls to send audio messages.",
  globalChatScrollToLatest: "Latest",
  globalChatMessageActions: "Message actions",
  globalChatQuickReactions: "Quick reactions",
  globalChatUnknownUser: "Unknown user",
  globalChatEditedMessage: "edited",
  globalChatDeliveryState: "Delivery state",
  globalChatSystemSender: "System",
  globalChatReply: "Reply",
  globalChatActionReply: "Reply",
  globalChatActionCopy: "Copy",
  globalChatActionEdit: "Edit",
  globalChatActionDelete: "Delete",
  globalChatActionPin: "Pin",
  globalChatActionUnpin: "Unpin",
  globalChatActionRetry: "Retry",
  globalChatActionDiscard: "Discard",
  globalChatRecordingVoiceMessage: "Recording voice message",
  globalChatVoiceRecordingPaused: "Voice recording paused",
  globalChatVoiceMessageReady: "Voice message ready",
  globalChatVoicePermissionError: "Microphone access failed.",
  globalChatVoiceValidationError: "Voice message is not supported.",
  globalChatStartVoiceRecording: "Start voice recording",
  globalChatVoicePreview: "Voice preview",
  globalChatPauseVoiceRecording: "Pause voice recording",
  globalChatStopVoiceRecording: "Stop voice recording",
  globalChatResumeVoiceRecording: "Resume voice recording",
  globalChatDiscardVoiceDraft: "Discard voice draft",
  globalChatSendVoiceMessage: "Send voice message",
  failedToDownloadFile: "Failed to download file",
  receivedRequesrSession: "Received session request from",
  sessionRequest: "Session request",
  sessionReques: "Session request",
  specialistConfirmedRequest: "Specialist confirmed request",
  canceledSession: "Canceled session",
  autoCancelSessionReason: "Request expired",
  direction: "Direction",
  topic: "Topic",
  result: "Result",
  infoModalComment: "Comment",
  projectRealTimeSession: "Project",
  reasonPlaceHodler: "Reason",
  reasonTitle: "Reason:",
  waitSpecResponse: "Waiting for specialist response",
};

export default strings;
